import { LoadablePaint } from '@confluence/loadable';

export const LazyTrashedSpacesPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TrashedSpacesContainer" */ '../src/TrashedSpaces/TrashedSpacesPage.tsx'
			)
		).TrashedSpacesPage,
});
